import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-select__wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("template", { slot: "no-options" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_3 = { class: "d-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["m-input", [{invalid: _ctx.noOptions || _ctx.invalid}, {'m-input_location': _ctx.location}, {'m-input_search': !_ctx.location}]]),
      "data-js": "m-input"
    }, [
      _createVNode(_component_joy_icon, {
        name: _ctx.iconName,
        class: "m-input__icon"
      }, null, 8, ["name"]),
      _createVNode(_component_vue_select, {
        ref: "select",
        modelValue: _ctx.selected,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
          _ctx.handleUpdatedValue
        ],
        "data-testid": _ctx.dataTestId,
        autocomplete: "on",
        filterable: false,
        label: _ctx.label,
        placeholder: _ctx.placeholder,
        options: _ctx.options,
        components: {
                    OpenIndicator: null,
                },
        onSearch: _ctx.onSearch,
        "onSearch:blur": _ctx.onSearchBlur,
        "onSearch:focus": _ctx.onFocus,
        "onOption:selected": _ctx.handleSelectValue
      }, {
        option: _withCtx((option) => [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", { option: option })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 3
      }, 8, ["modelValue", "data-testid", "label", "placeholder", "options", "onSearch", "onSearch:blur", "onSearch:focus", "onOption:selected", "onUpdate:modelValue"])
    ], 2),
    (_ctx.noOptions && _ctx.noOptionsLabel)
      ? (_openBlock(), _createBlock(_component_joy_form_error, {
          key: 0,
          "no-html-error-text": _ctx.noOptionsLabel
        }, null, 8, ["no-html-error-text"]))
      : _createCommentVNode("", true)
  ]))
}